import { useEffect, useState } from 'react';

interface LoadingIndicatorProps {
  label?: string;
}

// Числа сами по себе ничего не ускоряют, зато честно показывают, что панель работает,
// а не зависла — процент бежит к ~95% и никогда не "залипает" на месте, пока ждём ответ сервера
export default function LoadingIndicator({ label = 'Загрузка' }: LoadingIndicatorProps) {
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    const start = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - start;
      setPercent(Math.round(95 * (1 - Math.exp(-elapsed / 900))));
    }, 60);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-indicator">
      <svg className="loading-indicator-ring" viewBox="0 0 44 44">
        <circle className="loading-indicator-track" cx="22" cy="22" r="19" />
        <circle className="loading-indicator-arc" cx="22" cy="22" r="19" />
      </svg>
      <div className="loading-indicator-text">
        <span className="loading-indicator-percent">{percent}%</span>
        <span className="loading-indicator-label">{label}</span>
      </div>
    </div>
  );
}
